import { ReactNode, useMemo, useState } from 'react';
import { Nullable } from '../../utilities/common_types';
import { TokenContext } from './token_context';

interface TokenContextProviderProps {
  readonly children: ReactNode;
}
export function TokenContextProvider({ children }: TokenContextProviderProps) {
  const [token, setToken] = useState<Nullable<string>>(null);
  const [expiry, setExpiry] = useState<Nullable<Date>>(null);

  const contextValue = useMemo(
    () => ({ token, setToken, expiry, setExpiry }),
    [token, setToken, expiry, setExpiry]
  );
  return <TokenContext.Provider value={contextValue}>{children}</TokenContext.Provider>;
}
